import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkCTA } from 'Src/components/buttons/LinkCTA';
import Copy from 'Src/components/Copy';
import { SalidoIcon } from 'Src/components/icons/svg/SalidoIcon';
import { Flex } from 'Src/components/layout/Flex';
import { Page } from 'Src/feature/page/Page';
import { PageMain } from 'Src/feature/page/PageMain';
import useRoute from 'Src/routes/useRoute';

import styles from './ProvisionerLanding.module.scss';

const ProvisionerLanding: FC = () => {
  const { t } = useTranslation();
  const { crumbs } = useRoute();

  return (
    <Page
      main={(
        <PageMain
          main={(
            <div className={styles.pageContent}>
              <div className={styles.splash}>
                <video className={styles.splashItem} autoPlay muted loop poster="assets/background-preview.jpg">
                  <source src="assets/background-animated.mp4" type="video/mp4"/>
                </video>
              </div>
              <Flex fullWidth>
                <Flex horizontal alignItems="center" justifyContent="center" fullWidth>
                  <Copy variant="h6">{t('provision.landing.labels.welcomeTo')}</Copy>
                  <SalidoIcon className={styles.logo}/>
                </Flex>
                <Flex alignItems="center" justifyContent="center" className={styles.actionContainer}>
                  <Copy color="textSecondary" variant="body" size="lg" weight="bold">
                    {t('provision.landing.labels.setupYourDevice')}
                  </Copy>
                  <LinkCTA to={crumbs.provision.workflow.token.path} color="primary">
                    {t('provision.landing.labels.enterDeviceCode')}
                  </LinkCTA>
                  <Copy variant="body" size="lg" weight="bold">or</Copy>
                  <LinkCTA to={crumbs.provision.workflow.email.path} underline>
                    {t('provision.landing.labels.signInWithEmail')}
                  </LinkCTA>
                </Flex>
              </Flex>
            </div>
          )}
        />
      )}
    />
  );
};

export default ProvisionerLanding;
